import { StaticQuery, graphql, Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Logo from "./logo";

const Header = ({ toggleOffcanvas }) => (
  <StaticQuery
    query={graphql`
      query {
        wordpressSiteMetadata {
          name
        }
        allWordpressWpApiMenusMenusItems(
          filter: { slug: { eq: "main-menu" } }
        ) {
          edges {
            node {
              name
              items {
                title
                url
              }
            }
          }
        }
      }
    `}
    render={data => {
      const menu = data.allWordpressWpApiMenusMenusItems.edges[0].node;
      menu.items.map(item => {
        let parts = item.url.split("/");
        parts = parts.slice(3);
        item.slug = parts.join("/");
        return item.slug;
      });
      return (
        <nav className="navbar">
          <div className="container">
            <div className="navbar-brand">
              <Link to="/" className="navbar-item">
                <Logo />
              </Link>
              <span className="navbar-burger" onClick={() => toggleOffcanvas()}>
                menu
              </span>
            </div>
          </div>
        </nav>
      );
    }}
  />
);

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
